import { format } from 'date-fns'
import { FC, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import s from './Moderation.module.scss'

import { AllDataToModerate } from 'types/moderation'

import transformUTCToLocale from 'utils/transformUTCToLocale'

import { ClockIcon } from 'assets/icons/ClockIcon'
import { MoreIcon } from 'assets/icons/MoreIcon'
import { PublisherIcon } from 'assets/icons/PublisherIcon'
import metamaskIcon from 'assets/svg/icons-crypto-metamask.svg'

import { Card } from 'components/UI/Card/Card'
import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import { CustomSlider } from 'components/UI/CustomSlider/CustomSlider'

interface ModerationCardProps {
  item: AllDataToModerate
  declineHandler: () => void
  approveHandler: () => void
}

export const ModerationCard: FC<ModerationCardProps> = ({ item, declineHandler, approveHandler }) => {
  let navigate = useNavigate()

  const openAdSpotInfoModal = () => {
    navigate(`adspace/${item?.related_place.ad_spot_id}`)
  }

  const fromTime = format(transformUTCToLocale(item?.start_datetime), 'H:mm dd.MM.yyyy')
  const toTime = format(transformUTCToLocale(item?.finish_datetime), 'H:mm dd.MM.yyyy')

  const creativeImages = useMemo(
    () =>
      item?.audience.seg_rules
        .map((seg_rule) => seg_rule.seg_rule_creatives)
        .reduce((k, v) => [...k, ...v], [])
        .map((creative) => creative.creative.url),
    [JSON.stringify(item?.audience?.seg_rules)]
  )

  return (
    <div className={s.moderationGrid}>
      <Card variant="primary" className={s.cardCampaignInfo}>
        <Card.Image height={'19.688rem'}>
          <CustomSlider
            images={creativeImages}
            style={{ maxHeight: '19.688rem' }}
            itemStyle={{ height: '19.688rem', width: 560 }}
          />
        </Card.Image>
        <Card.Info className={s.campaignInfo}>
          <div className={s.creativeCardContentTop}>
            <h3 className={s.creativeCardTitle}>{item?.name}</h3>
          </div>
          <p className={s.creativeCardText}>{item?.description}</p>
        </Card.Info>
      </Card>
      <div className={s.right}>
        <div className={s.rightCardsWrapper}>
          <Card variant="primary">
            <Card.Info className={s.advertiserInfo}>
              <ul className={s.list}>
                <li className={s.list__item}>
                  <div className={s.icon}>
                    <ClockIcon className={s.clockIcon} />
                  </div>
                  <div className={s.text}>
                    <p className={s.top}>
                      <span className={s.noSpaceWrap}>{fromTime}</span> -{' '}
                      <span className={s.noSpaceWrap}>{toTime}</span>
                    </p>
                    <p className={s.bottom}>Requested Timeslot</p>
                  </div>
                </li>
              </ul>
              <CustomButton variant="outlined" className={s.advertName} size="240">
                <img src={metamaskIcon} alt="" className={s.advertiserIcon} />
                <span className={s.userName}>{item?.advertiser?.name || item?.advertiser?.login}</span>
              </CustomButton>
            </Card.Info>
          </Card>
          <Card variant="primary">
            <Card.Info className={s.adSpaceInfo}>
              <ul className={s.list}>
                <li className={s.list__item}>
                  <div className={s.icon}>
                    <PublisherIcon className={s.publisherIcon} />
                  </div>
                  <div className={s.text}>
                    <p className={s.top}>Decentraland Ad Space</p>
                    <p className={s.bottom}>Requested Ad Space</p>
                  </div>
                </li>
              </ul>
              <a
                href="#0"
                className={s.linkButton}
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  e.nativeEvent.stopImmediatePropagation()
                  openAdSpotInfoModal()
                }}
              >
                <MoreIcon className={s.adspotInfo} />
                Ad Space Details
              </a>
            </Card.Info>
          </Card>
        </div>
        <div className={s.btnWrapper}>
          <CustomButton variant="success" onClick={approveHandler} size="180">
            Approve
          </CustomButton>
          <CustomButton variant="danger" onClick={declineHandler} size="180">
            Decline
          </CustomButton>
        </div>
      </div>
    </div>
  )
}

export default ModerationCard
